import { useSiteContext, useTranslations } from "@dustin-web/microsite-components/src/hooks"
import { useFormContext } from "react-hook-form"
import { StandardRegisterProps } from "src/components/registerBusiness/standardRegister"
import { customerService } from "src/constants/links"

const AdditinonalUserRequestSent = () => {
  const { translate } = useTranslations()
  const { getValues } = useFormContext<StandardRegisterProps>()
  const { site } = useSiteContext()
  const customerServiceEmail = customerService.email[site]

  return (
    <div className="row">
      <div className="col">
        <h1 className="u-mb-8">
          {translate("Register_Request_Sent_Header")}
        </h1>
        <p className="u-fs-20 u-mb-16">
          {translate("Register_Request_Sent_Description")}
          <br />
          <span className="u-fw-bold">{getValues("email")}</span>
        </p>
        <p>
          {translate("Register_Request_Sent_Contact_Customer_Service")}
          <br />
          {customerServiceEmail}
        </p>

      </div>
    </div>
  )
}

export default AdditinonalUserRequestSent
